module.exports = __webpack_public_path__ + "img/download_white.473e14de.svg";